export const TABLE_GROUP_TYPE = Symbol('group');
